import React from "react";

export default function Loader() {
  return (
    <div className="flex items-center justify-center h-screen w-full bg-transparent">
      <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#EFA938]"></div>
    </div>
  );
}

